import { useQuery } from "@apollo/client";
import Errors from "components/base/Errors";
import Spinner from "components/base/Spinner";
import { Navigate, useParams } from "react-router-dom";
import { FETCH_PO_QC_REPORT } from "../graphql.js";
import PoFinalQcReportPage from "./PoFinalQcReportPage.js";

function PoQcReportPage() {
  const { id } = useParams();
  const fromUrl = new URLSearchParams(window.location.search).get("from");
  const { loading, error, data } = useQuery(FETCH_PO_QC_REPORT, {
    variables: { id },
  });

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  const report = data.report;
  if (!report.po) {
    return <Navigate to={`/qc/reports/${id}`} replace />;
  }

  return <PoFinalQcReportPage report={report} fromUrl={fromUrl} />;
}

export default PoQcReportPage;
